/* POWDER FASHION — ALPINE THEME — global.js
   One-page shopping: quick-view overlay + AJAX cart. Calm and minimal. */
(function () {
  "use strict";

  var PFS = (window.PFStrings || {});
  function pfs(key, fallback){ return (PFS && PFS[key]) || fallback; }
  /* ============ Helpers ============ */
  function formatMoneyFactory(moneyFormat) {
    return function (cents) {
      var amount = (cents / 100).toFixed(2);
      var withComma = amount.replace(".", ",");
      return (moneyFormat || "€{{amount_with_comma_separator}}")
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
        .replace(/\{\{\s*amount\s*\}\}/, amount);
    };
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.querySelector(".cart-link");
        if (!link) return;
        var badge = link.querySelector(".cart-count");
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement("span");
            badge.className = "cart-count";
            link.appendChild(badge);
          }
          badge.textContent = cart.item_count;
        } else if (badge) {
          badge.remove();
        }
      })
      .catch(function () {});
  }

  /* ============ Cart toast ============ */
  var toast;
  function showToast(title) {
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "cart-toast";
      toast.setAttribute("role", "status");
      toast.innerHTML =
        '<button class="cart-toast__close" aria-label="' + pfs('close', "Close") + '">✕</button>' +
        '<div class="cart-toast__title"><span class="tick">✓</span>' + pfs('added_to_cart', "Added to cart") + '</div>' +
        '<div class="cart-toast__item"></div>' +
        '<div class="cart-toast__actions">' +
        '<a class="btn btn--ghost on-dark" href="/cart">' + pfs('view_cart', "View cart") + '</a>' +
        '<a class="btn btn--primary" href="/checkout">' + pfs('checkout', "Checkout") + '</a>' +
        "</div>";
      document.body.appendChild(toast);
      toast.querySelector(".cart-toast__close").addEventListener("click", function () {
        toast.classList.remove("is-open");
      });
    }
    toast.querySelector(".cart-toast__item").textContent = title || "";
    toast.classList.add("is-open");
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove("is-open"); }, 6000);
  }

  /* ============ Cart drawer (slide-in, direct checkout) ============ */
  var SE = window.PFSettings || {};
  var drawerMoney = formatMoneyFactory(SE.moneyFormat);
  var drawerWrap, drawerPanel, drawerLastFocus;

  function ensureDrawer() {
    if (drawerWrap) return;
    drawerWrap = document.createElement("div");
    drawerWrap.className = "cart-drawer-wrap";
    drawerWrap.innerHTML =
      '<div class="cart-drawer__backdrop" data-drawer-close></div>' +
      '<aside class="cart-drawer" role="dialog" aria-modal="true" aria-label="' + pfs('shopping_cart', "Shopping cart") + '">' +
      '<div class="cart-drawer__head">' +
      '<span class="cart-drawer__title">' + pfs('cart_title', "Your cart") + ' <span class="cart-drawer__count" data-drawer-count></span></span>' +
      '<button class="cart-drawer__close" data-drawer-close aria-label="' + pfs('close_cart', "Close cart") + '">✕</button>' +
      "</div>" +
      (SE.saleEnabled
        ? '<div class="cart-drawer__sale">' + (SE.saleTitle || "Sale") + ": " + SE.salePercent + pfs('sale_everything', "% off everything · applied automatically at checkout") + "</div>"
        : "") +
      '<div class="cart-drawer__items" data-drawer-items></div>' +
      '<div class="cart-drawer__foot" data-drawer-foot></div>' +
      "</aside>";
    document.body.appendChild(drawerWrap);
    drawerPanel = drawerWrap.querySelector(".cart-drawer");

    drawerWrap.addEventListener("click", function (e) {
      if (e.target.closest("[data-drawer-close]")) closeDrawer();
      var rm = e.target.closest("[data-drawer-remove]");
      if (rm) {
        rm.disabled = true;
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: rm.getAttribute("data-drawer-remove"), quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) { renderDrawer(cart); updateCartCount(); })
          .catch(function () { rm.disabled = false; });
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawerWrap.classList.contains("is-open")) closeDrawer();
    });
  }

  function renderDrawer(cart) {
    ensureDrawer();
    var countEl = drawerWrap.querySelector("[data-drawer-count]");
    var itemsEl = drawerWrap.querySelector("[data-drawer-items]");
    var footEl = drawerWrap.querySelector("[data-drawer-foot]");
    countEl.textContent = cart.item_count > 0 ? "(" + cart.item_count + ")" : "";

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="cart-drawer__empty">' +
        "<p>" + pfs('cart_empty', "Your cart is empty.") + "</p>" +
        '<a class="btn btn--ghost on-dark" href="/collections/all">' + pfs('shop_collection', "Shop the collection") + '</a>' +
        "</div>";
      footEl.innerHTML = "";
      clearReservation();
      return;
    }

    var html = "";
    cart.items.forEach(function (item) {
      var img = item.image
        ? item.image + (item.image.indexOf("?") > -1 ? "&" : "?") + "width=280"
        : "";
      html +=
        '<div class="cart-drawer__line">' +
        (img ? '<img src="' + img + '" alt="" width="96" height="120" loading="lazy">' : '<span class="cart-drawer__noimg"></span>') +
        '<div class="cart-drawer__line-info">' +
        '<span class="cart-drawer__line-title">' + item.product_title + "</span>" +
        (item.variant_title && item.variant_title !== "Default Title"
          ? '<span class="cart-drawer__line-variant">' + item.variant_title + "</span>"
          : "") +
        '<span class="cart-drawer__line-qty">' + pfs('qty', "Qty") + " " + item.quantity + "</span>" +
        "</div>" +
        '<div class="cart-drawer__line-side">' +
        '<span class="cart-drawer__line-price">' + drawerMoney(item.final_line_price) + "</span>" +
        '<button class="cart-drawer__remove" data-drawer-remove="' + item.key + '" aria-label="' + pfs('remove', "Remove") + " " + item.product_title.replace(/"/g, "&quot;") + '">' + pfs('remove', "Remove") + '</button>' +
        "</div>" +
        "</div>";
    });
    itemsEl.innerHTML = html;

    var rows =
      '<div class="cart-drawer__row"><span>' + pfs('subtotal', "Subtotal") + '</span><span>' + drawerMoney(cart.items_subtotal_price) + "</span></div>" +
      '<div class="cart-drawer__row"><span>' + pfs('shipping', "Shipping") + '</span><span>' + pfs('free', "Free") + '</span></div>';
    if (cart.total_discount > 0) {
      rows += '<div class="cart-drawer__row cart-drawer__row--save"><span>' + pfs('you_save', "You save") + '</span><span>−' + drawerMoney(cart.total_discount) + "</span></div>";
    } else if (SE.saleEnabled) {
      rows += '<div class="cart-drawer__row cart-drawer__row--save"><span>' + (SE.saleTitle || "Sale") + " −" + SE.salePercent + "%</span><span>" + pfs('at_checkout', "at checkout") + "</span></div>";
    }
    rows += '<div class="cart-drawer__row cart-drawer__row--total"><span>' + pfs('total', "Total") + '</span><span>' + drawerMoney(cart.total_price) + "</span></div>";

    footEl.innerHTML =
      rows +
      '<div class="cart-timer" data-cart-timer><span class="cart-timer__dot"></span>' +
      '<span data-cart-timer-text>' + pfs('reserved_for', "Your items are reserved for") + ' <span class="cart-timer__clock" data-cart-timer-clock>10:00</span></span></div>' +
      '<a class="btn btn--primary btn--lg btn--full cart-drawer__checkout" href="/checkout">' + pfs('checkout', "Checkout") + ' <span class="btn__arrow">→</span></a>' +
      '<a class="cart-drawer__viewcart" href="' + (SE.cartUrl || "/cart") + '">' + pfs('view_full_cart', "View full cart") + '</a>' +
      '<span class="cart-drawer__trust"><span class="tick">✓</span> ' + pfs('drawer_trust', "Secure checkout · 14-day returns · Free worldwide shipping") + '</span>';

    renderCartTimers();
  }

  function openDrawer() {
    ensureDrawer();
    drawerLastFocus = document.activeElement;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        if (typeof closeQuickView === "function") closeQuickView();
        drawerWrap.classList.add("is-open");
        document.body.classList.add("drawer-lock");
        drawerPanel.focus && drawerPanel.focus();
      })
      .catch(function () {
        window.location.href = SE.cartUrl || "/cart";
      });
  }

  function closeDrawer() {
    if (!drawerWrap) return;
    drawerWrap.classList.remove("is-open");
    document.body.classList.remove("drawer-lock");
    if (drawerLastFocus) drawerLastFocus.focus();
  }

  /* Cart icon opens the drawer instead of navigating (except on the cart page) */
  document.addEventListener("click", function (e) {
    var link = e.target.closest(".cart-link");
    if (!link) return;
    if (document.body.classList.contains("template-cart")) return;
    e.preventDefault();
    openDrawer();
  });

  function ajaxAddToCart(formData, btn, btnText, itemTitle) {
    if (btn) { btn.disabled = true; }
    if (btnText) { btnText.textContent = pfs('adding', "Adding…"); }
    return fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function (item) {
        updateCartCount();
        resetReservation();
        openDrawer();
        if (btnText) { btnText.textContent = pfs('added', "Added ✓"); }
        setTimeout(function () {
          if (btn) btn.disabled = false;
          if (btnText) btnText.textContent = btnText.getAttribute("data-default") || pfs('add_to_cart', "Add to cart");
        }, 1600);
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        if (btnText) btnText.textContent = btnText.getAttribute("data-default") || pfs('add_to_cart', "Add to cart");
        showToast(pfs('error_generic', "Something went wrong, please try again"));
      });
  }

  /* ============ Variant image switching (pick Blue → see blue shirt) ============ */
  function imageBasename(src) {
    return (src || "").split("?")[0].split("/").pop();
  }
  function showVariantImage(rootEl, variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.src) return;
    var want = imageBasename(variant.featured_image.src);

    /* Quick-view carousel: jump to the matching slide */
    var carousel = rootEl.querySelector("[data-carousel]");
    if (carousel && carousel._go) {
      var slides = [].slice.call(carousel.querySelectorAll(".qv__slide img"));
      for (var i = 0; i < slides.length; i++) {
        if (imageBasename(slides[i].getAttribute("src")) === want) {
          carousel._go(i);
          return;
        }
      }
    }

    /* Product page gallery: swap the main image to the variant's image */
    var thumbs = [].slice.call(rootEl.querySelectorAll("[data-gallery-thumb]"));
    for (var j = 0; j < thumbs.length; j++) {
      if (thumbs[j].getAttribute("data-basename") === want) {
        if (thumbs[j]._show) thumbs[j]._show();
        return;
      }
    }
  }

  /* ============ Product gallery: main image + thumbnails ============ */
  function initGallery(rootEl) {
    var gallery = rootEl.querySelector("[data-gallery]");
    if (!gallery) return;
    var main = gallery.querySelector("[data-gallery-main]");
    var thumbs = [].slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
    if (!main || !thumbs.length) return;
    var current = Math.max(0, thumbs.findIndex(function (t) { return t.classList.contains("is-active"); }));
    function show(i, smooth) {
      current = (i + thumbs.length) % thumbs.length;
      var t = thumbs[current];
      main.classList.add("is-switching");
      var swap = function () {
        main.setAttribute("src", t.getAttribute("data-full"));
        main.setAttribute("srcset", t.getAttribute("data-srcset"));
        main.setAttribute("alt", t.querySelector("img").getAttribute("alt") || "");
        main.classList.remove("is-switching");
      };
      setTimeout(swap, 120);
      thumbs.forEach(function (x, k) { x.classList.toggle("is-active", k === current); });
      if (smooth !== false) t.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
    thumbs.forEach(function (t, i) {
      t._show = function () { show(i); };
      t.addEventListener("click", function () { show(i); });
    });
    var prev = gallery.querySelector("[data-gallery-prev]"), next = gallery.querySelector("[data-gallery-next]");
    if (prev) prev.addEventListener("click", function () { show(current - 1); });
    if (next) next.addEventListener("click", function () { show(current + 1); });
    /* swipe on touch */
    var sx = null;
    var stage = gallery.querySelector(".product-gallery__stage");
    stage.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener("touchend", function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) show(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });
  }

  /* ============ Product form (variant picker), reusable ============ */
  function initProductForm(rootEl, opts) {
    opts = opts || {};
    var dataScript = rootEl.querySelector("[data-product-json]");
    if (!dataScript) return;
    var product;
    try { product = JSON.parse(dataScript.textContent); } catch (err) { return; }

    var formatMoney = formatMoneyFactory(rootEl.getAttribute("data-money-format"));
    var salePct = parseInt(rootEl.getAttribute("data-sale-percent"), 10) || 0;
    var idInput = rootEl.querySelector('input[name="id"]');
    var priceEl = rootEl.querySelector("[data-price]");
    var compareEl = rootEl.querySelector("[data-compare-price]");
    var buyBtn = rootEl.querySelector("[data-add-to-cart]");
    var buyText = rootEl.querySelector("[data-add-to-cart-text]");

    function update() {
      var selected = [].slice
        .call(rootEl.querySelectorAll("[data-option-input]:checked"))
        .map(function (i) { return i.value; });

      var match = product.variants.find(function (v) {
        return selected.every(function (val, idx) { return v.options[idx] === val; });
      });

      rootEl.querySelectorAll("[data-option-value]").forEach(function (el) {
        var idx = parseInt(el.getAttribute("data-option-value"), 10);
        if (selected[idx]) el.textContent = selected[idx];
      });

      if (!match) {
        if (buyBtn) buyBtn.disabled = true;
        if (buyText) buyText.textContent = pfs('unavailable', "Unavailable");
        return;
      }
      if (idInput) idInput.value = match.id;
      var displayPrice = match.price;
      var compareAt = match.compare_at_price && match.compare_at_price > match.price ? match.compare_at_price : null;
      if (!compareAt && salePct > 0) {
        /* Site-wide sale: show the discounted price, original struck through */
        displayPrice = Math.round(match.price * (100 - salePct) / 100);
        compareAt = match.price;
      }
      if (priceEl) priceEl.textContent = formatMoney(displayPrice);
      if (compareEl) {
        if (compareAt) {
          compareEl.style.display = "";
          compareEl.textContent = formatMoney(compareAt);
        } else {
          compareEl.style.display = "none";
        }
      }
      if (buyBtn && buyText) {
        if (match.available) {
          buyBtn.disabled = false;
          buyText.textContent = buyText.getAttribute("data-default") || pfs('add_to_cart', "Add to cart");
        } else {
          buyBtn.disabled = true;
          buyText.textContent = pfs('sold_out', "Sold out");
        }
      }
      showVariantImage(rootEl, match);
    }

    rootEl.addEventListener("change", function (e) {
      if (e.target.matches("[data-option-input]")) update();
    });
    update();

    if (opts.ajax) {
      var form = rootEl.querySelector("[data-qv-form]");
      if (form) {
        form.addEventListener("submit", function (e) {
          e.preventDefault();
          ajaxAddToCart(new FormData(form), buyBtn, buyText, product.title);
        });
      }
    }
  }

  /* ============ Carousel (inside quick view) ============ */
  function initCarousel(rootEl) {
    var carousel = rootEl.querySelector("[data-carousel]");
    if (!carousel) return;
    var slides = [].slice.call(carousel.querySelectorAll(".qv__slide"));
    var dots = [].slice.call(carousel.querySelectorAll("[data-carousel-dot]"));
    if (slides.length < 2) return;
    var idx = 0;

    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle("is-active", i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
    }

    carousel._go = go;
    var prev = carousel.querySelector("[data-carousel-prev]");
    var next = carousel.querySelector("[data-carousel-next]");
    if (prev) prev.addEventListener("click", function () { go(idx - 1); });
    if (next) next.addEventListener("click", function () { go(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener("click", function () { go(i); }); });

    var startX = null;
    carousel.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener("touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? idx + 1 : idx - 1);
      startX = null;
    }, { passive: true });
  }

  /* ============ Quick-view overlay ============ */
  var overlay, panel, lastFocus;

  function ensureOverlay() {
    if (overlay) return;
    overlay = document.createElement("div");
    overlay.className = "qv-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.innerHTML =
      '<button class="qv-overlay__close" data-qv-close aria-label="' + pfs('close', "Close") + '">✕</button>' +
      '<div class="qv-overlay__panel" tabindex="-1"></div>';
    document.body.appendChild(overlay);
    panel = overlay.querySelector(".qv-overlay__panel");

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay || e.target.closest("[data-qv-close]")) closeQuickView();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && overlay.classList.contains("is-open")) closeQuickView();
    });
  }

  function openQuickView(url) {
    ensureOverlay();
    lastFocus = document.activeElement;
    panel.innerHTML = '<div style="padding:5rem; text-align:center;" class="mono-label">' + pfs('loading', "Loading…") + '</div>';
    overlay.classList.add("is-open");
    document.body.classList.add("qv-lock");

    var sep = url.indexOf("?") > -1 ? "&" : "?";
    fetch(url + sep + "view=quick")
      .then(function (r) {
        if (!r.ok) throw new Error("fetch failed");
        return r.text();
      })
      .then(function (html) {
        panel.innerHTML = html;
        var qvRoot = panel.querySelector("[data-product]");
        if (qvRoot) {
          initProductForm(qvRoot, { ajax: true });
          initCarousel(qvRoot);
        }
        panel.focus();
      })
      .catch(function () {
        window.location.href = url; /* graceful fallback to product page */
      });
  }

  function closeQuickView() {
    if (!overlay) return;
    overlay.classList.remove("is-open");
    document.body.classList.remove("qv-lock");
    setTimeout(function () { panel.innerHTML = ""; }, 350);
    if (lastFocus) lastFocus.focus();
  }

  /* Touch: hold finger on a card photo to see the back view */
  var holdTimer = null;
  var holdMedia = null;
  var suppressCardClick = false;
  function endHold() {
    if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
    if (holdMedia) { holdMedia.classList.remove("show-alt"); holdMedia = null; }
  }
  document.addEventListener("touchstart", function (e) {
    var media = e.target.closest(".product-card__media");
    if (!media || !media.querySelector("img.alt")) return;
    holdMedia = media;
    holdTimer = setTimeout(function () {
      holdTimer = null;
      media.classList.add("show-alt");
      suppressCardClick = true; /* a hold is not a tap — don't open the popup on release */
    }, 200);
  }, { passive: true });
  document.addEventListener("touchmove", function () {
    if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; } /* scrolling — cancel pending hold */
  }, { passive: true });
  document.addEventListener("touchend", endHold, { passive: true });
  document.addEventListener("touchcancel", endHold, { passive: true });

  /* Open quick view when a product card or "Choose options" is clicked (stay on page) */
  document.addEventListener("click", function (e) {
    var card = e.target.closest(".product-card");
    if (!card) return;
    if (suppressCardClick) { suppressCardClick = false; e.preventDefault(); return; }
    if (e.target.closest(".quick-buy button")) return; /* size quick-add buttons handle themselves */
    /* Laat nieuw-tabblad toe wanneer er bewust op een echte link wordt geklikt */
    if ((e.metaKey || e.ctrlKey || e.shiftKey) && e.target.closest("a[href*='/products/']")) return;
    /* Klik ergens op de kaart (foto, titel, prijs, choose options) opent het venster */
    var link = card.querySelector("a[href*='/products/']");
    if (!link) return;
    e.preventDefault();
    openQuickView(link.getAttribute("href").split("?")[0]);
  });

  /* ============ Quick-add size buttons on cards (AJAX) ============ */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest(".quick-buy form");
    if (!form) return;
    e.preventDefault();
    var btn = e.submitter;
    var fd = new FormData();
    fd.append("id", btn && btn.value ? btn.value : form.querySelector("button[name='id']").value);
    fd.append("quantity", "1");
    var card = form.closest(".product-card");
    var title = card ? (card.querySelector(".product-card__title") || {}).textContent : "";
    ajaxAddToCart(fd, btn, null, title && btn ? title.trim() + ", " + btn.textContent.trim() : title);
  });

  /* ============ Product page form (AJAX too, stays consistent) ============ */
  var pageProduct = document.querySelector("main [data-product]");
  if (pageProduct && !pageProduct.closest(".qv-overlay")) {
    initGallery(pageProduct);
    initProductForm(pageProduct, { ajax: false });
    var pageForm = pageProduct.querySelector('form[action*="/cart/add"]');
    if (pageForm) {
      pageForm.addEventListener("submit", function (e) {
        var submitter = e.submitter;
        if (submitter && submitter.name === "add") {
          e.preventDefault();
          var btn = pageProduct.querySelector("[data-add-to-cart]");
          var btnText = pageProduct.querySelector("[data-add-to-cart-text]");
          ajaxAddToCart(new FormData(pageForm), btn, btnText, null);
        }
      });
    }
  }

  /* ============ Subtle reveal on scroll ============ */
  var revealEls = [].slice.call(document.querySelectorAll(".reveal, .reveal-stagger"));
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -6% 0px", threshold: 0.06 }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in-view"); });
  }

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ============ Slim scroll progress line ============ */
  if (!reducedMotion) {
    var race = document.createElement("div");
    race.className = "race-progress";
    race.setAttribute("aria-hidden", "true");
    race.innerHTML =
      '<div class="race-progress__track"></div>' +
      '<div class="race-progress__fill"></div>';
    document.body.appendChild(race);

    var raceFill = race.querySelector(".race-progress__fill");
    var raceTicking = false;
    var updateRace = function () {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
      raceFill.style.transform = "scaleX(" + p + ")";
      raceTicking = false;
    };
    window.addEventListener("scroll", function () {
      if (!raceTicking) { window.requestAnimationFrame(updateRace); raceTicking = true; }
    }, { passive: true });
    updateRace();
  }

  /* ============ Count-up numbers on scroll ============ */
  var counters = [].slice.call(document.querySelectorAll("[data-count]"));
  if (counters.length) {
    var animateCount = function (el) {
      var target = parseInt(el.getAttribute("data-count"), 10) || 0;
      if (reducedMotion || target === 0) { el.textContent = target; return; }
      var dur = 2600;
      var start = null;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3); /* ease-out cubic */
        el.textContent = Math.round(eased * target);
        if (p < 1) window.requestAnimationFrame(step);
      };
      window.requestAnimationFrame(step);
    };
    if ("IntersectionObserver" in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            cio.unobserve(entry.target);
          }
        });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { cio.observe(el); });
    } else {
      counters.forEach(animateCount);
    }
  }

  /* ============ Product row arrows (swipe rows) ============ */
  document.addEventListener("click", function (e) {
    var prev = e.target.closest("[data-row-prev]");
    var next = e.target.closest("[data-row-next]");
    if (!prev && !next) return;
    var id = prev ? prev.getAttribute("data-row-prev") : next.getAttribute("data-row-next");
    var row = document.getElementById(id);
    if (!row) return;
    var card = row.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 24 : 320;
    row.scrollBy({ left: prev ? -step * 2 : step * 2, behavior: "smooth" });
  });

  /* ============ Smooth anchor scrolling ============ */
  document.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#"], a[href^="/#"]');
    if (!a) return;
    var hash = a.getAttribute("href").replace(/^\//, "");
    if (hash.length < 2) return;
    var target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  /* ============ Mobile menu ============ */
  var menuToggle = document.querySelector("[data-menu-open]");
  var menuClose = document.querySelector("[data-menu-close]");
  var mobileMenu = document.querySelector(".mobile-menu");
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", function () {
      mobileMenu.classList.add("is-open");
      document.body.style.overflow = "hidden";
    });
  }
  if (menuClose && mobileMenu) {
    menuClose.addEventListener("click", function () {
      mobileMenu.classList.remove("is-open");
      document.body.style.overflow = "";
    });
  }
  if (mobileMenu) {
    mobileMenu.addEventListener("click", function (e) {
      if (e.target.closest("a")) {
        mobileMenu.classList.remove("is-open");
        document.body.style.overflow = "";
      }
    });
  }

  /* ============ Quantity steppers ============ */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty]");
    if (!btn) return;
    var input = btn.parentElement.querySelector("input");
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = input.min === "0" ? 0 : 1;
    if (btn.getAttribute("data-qty") === "up") val += 1;
    else val = Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });


  /* ============ Reservation timer (10 minutes) ============ */
  var RESERVE_MS = 10 * 60 * 1000;
  var RESERVE_KEY = "pf_reserve_start";
  var reserveTick = null;

  function reserveStore(value) {
    try {
      if (value === null) window.localStorage.removeItem(RESERVE_KEY);
      else window.localStorage.setItem(RESERVE_KEY, String(value));
    } catch (err) { /* storage unavailable */ }
  }

  function reserveRead() {
    try {
      var raw = window.localStorage.getItem(RESERVE_KEY);
      var n = raw ? parseInt(raw, 10) : 0;
      return n > 0 ? n : 0;
    } catch (err) { return 0; }
  }

  /* Called whenever something lands in the cart: restart the 10 minutes */
  function resetReservation() {
    reserveStore(Date.now());
    renderCartTimers();
  }

  function clearReservation() {
    reserveStore(null);
    renderCartTimers();
  }

  function renderCartTimers() {
    var nodes = document.querySelectorAll("[data-cart-timer]");
    if (!nodes.length) {
      if (reserveTick) { clearInterval(reserveTick); reserveTick = null; }
      return;
    }
    var start = reserveRead();
    if (!start) { start = Date.now(); reserveStore(start); }
    var left = Math.max(0, RESERVE_MS - (Date.now() - start));
    var mins = Math.floor(left / 60000);
    var secs = Math.floor((left % 60000) / 1000);
    var clock = mins + ":" + (secs < 10 ? "0" : "") + secs;

    nodes.forEach(function (node) {
      node.hidden = false;
      var clockEl = node.querySelector("[data-cart-timer-clock]");
      var textEl = node.querySelector("[data-cart-timer-text]");
      if (left <= 0) {
        node.classList.add("cart-timer--expired");
        if (textEl) textEl.textContent = pfs('reservation_expired', "Reservation expired, your items are still in the cart");
      } else {
        node.classList.remove("cart-timer--expired");
        if (!clockEl && textEl) {
          textEl.innerHTML = pfs('reserved_for', "Your items are reserved for") + ' <span class="cart-timer__clock" data-cart-timer-clock></span>';
          clockEl = node.querySelector("[data-cart-timer-clock]");
        }
        if (clockEl) clockEl.textContent = clock;
      }
    });

    if (!reserveTick) {
      reserveTick = setInterval(function () {
        if (!document.querySelector("[data-cart-timer]")) {
          clearInterval(reserveTick); reserveTick = null; return;
        }
        renderCartTimers();
      }, 1000);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-cart-timer]")) renderCartTimers();
  });
  if (document.readyState !== "loading" && document.querySelector("[data-cart-timer]")) renderCartTimers();

  /* ============ Cart page: auto submit on qty change ============ */
  var cartForm = document.querySelector("[data-cart-form]");
  if (cartForm) {
    cartForm.addEventListener("change", function (e) {
      if (e.target.matches("[data-cart-qty]")) cartForm.submit();
    });
  }
})();
